import { cn } from "@/lib/utils";

export default function HeroBackground({ className }: { className?: string }) {
    return (
        <div
            className={cn("absolute inset-0", className)}
            style={{
                background: "linear-gradient(180deg,rgba(23, 38, 79, 1) 0%, rgba(37, 63, 142, 1) 50%, rgba(255, 255, 255, 1) 125%)"
            }}
        >
            <div className="bg-black h-full opacity-25" />
        </div>
    );
}